import { LOAD_ATTACHMENTS } from "./types";

export const loadAttachments = (attachments) => (dispatch) => {
  dispatch({
    type: LOAD_ATTACHMENTS,
    payload: attachments,
  });
};
